/**
 * Add Label Set Swatch Handler
 * ----------------------------
 * When the "Add Label Set" option is selected, adds an extra product
 * based on quantity-specific variant ID and the "Design" property.
 */

document.addEventListener('DOMContentLoaded', () => {
  observeDOMForLabelSetSwatch();
});

function observeDOMForLabelSetSwatch() {
  const observer = new MutationObserver(() => {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const swatchInput = document.querySelector('input[name="properties[Add On Labels]"][value="Add Label Set"]');

    if (form && swatchInput && !form.dataset.labelSetBound) {
      form.dataset.labelSetBound = 'true';
      attachLabelSetHandler(form, swatchInput);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function attachLabelSetHandler(form, swatchInput) {
  const submitBtn = form.querySelector('[type="submit"]');

  const quantityVariantMap = {
    1: 50235202109743,
    2: 50235202142511,
    3: 50235202175279,
  };

  form.addEventListener('submit', (e) => {
    if (!swatchInput.checked) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const formData = new FormData(form);
    const mainVariantId = formData.get('id');

    const quantityLabel = formData.get('properties[Sheet Quantity]') || '';
    const quantityValue = parseInt(quantityLabel.match(/\d+/)?.[0] || '1', 10);
    const design = formData.get('properties[Color]') || formData.get('properties[Design]') || 'Default';

    const extraVariantId = quantityVariantMap[quantityValue];

    if (!mainVariantId || !extraVariantId) {
      console.warn('🟠 Missing variant ID(s):', { mainVariantId, extraVariantId });
      return;
    }

    const mainProps = extractMainProps(formData);
    const extraProps = extractExtraProps(formData, design);

    const payload = {
      items: [
        {
          id: Number(mainVariantId),
          quantity: 1,
          properties: mainProps,
        },
        {
          id: Number(extraVariantId),
          quantity: 1,
          properties: extraProps,
        },
      ],
    };

    disableButton(submitBtn, 'Adding...');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(res => res.json())
      .then(data => {
        if (window.cartDrawer) {
          window.cartDrawer.renderContents(data);
        } else if (window.cartNotification) {
          window.cartNotification.renderContents(data);
        }
      })
      .catch(err => {
        console.error('🛑 Failed to add to cart:', err);
        alert('Something went wrong while adding to cart.');
      })
      .finally(() => {
        enableButton(submitBtn, 'Add to Cart');
      });
  }, { capture: true });
}

function extractMainProps(formData) {
  const props = {};

  for (const [key, value] of formData.entries()) {
    if (!key.startsWith('properties[') || !value.trim()) continue;

    const rawKey = key.replace(/^properties\[/, '').replace(/\]$/, '');

    if (
      rawKey.startsWith('_') ||
      rawKey === 'Color' || 
      rawKey === 'Design' || 
      rawKey === 'Icon'
    ) {
      props[rawKey] = value.trim();
    } else if (rawKey.toLowerCase() === 'sku') {
      props['_SKU'] = value.trim();
    } else if (
      rawKey === 'Sheet Quantity' ||
      rawKey === 'Add On Labels'
    ) {
      continue;
    } else {
      props[formatLabel(rawKey)] = value.trim();
    }
  }

  return props;
}


function extractExtraProps(formData, design) {
  const props = { Design: design };

  for (const [key, value] of formData.entries()) {
    if (key.startsWith('properties[') && value.trim()) {
      const rawKey = key.replace(/^properties\[/, '').replace(/\]$/, '');
      const label = formatLabel(rawKey);

      if (label === 'Line 1' || label === 'Line 2') {
        props[label] = value.trim();
      }
    }
  }

  return props;
}

function formatLabel(str) {
  return str
    .replace(/^_option_/, '')
    .replace(/^option_line_/, 'Line ')
    .replace(/_/g, ' ')
    .replace(/\bid\b/i, 'ID')
    .replace(/\b\w/g, (match) => match.toUpperCase())
    .trim();
}

function disableButton(button, loadingText = 'Adding...') {
  button.disabled = true;
  const span = button.querySelector('span');
  if (span) {
    span.dataset.originalText = span.innerText;
    span.innerText = loadingText;
  }
}

function enableButton(button, defaultText = 'Add to Cart') {
  button.disabled = false;
  const span = button.querySelector('span');
  if (span) {
    span.innerText = span.dataset.originalText || defaultText;
    delete span.dataset.originalText;
  }
}
